var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"pricing"}},[_c('Pricing1'),_c('Pricing2'),_c('Pricing3'),_c('Pricing4'),_c('Pricing5')],1)}
var staticRenderFns = []

export { render, staticRenderFns }